<template>
  <div id="app">
    <div v-if="liad_show">
      <load></load>
    </div>
  <div class="maincon">
    <div>
      <el-select v-model="companyee_choiced"  multiple filterable placeholder="请选择" style="float: left;">
        <el-option
          v-for="item in companyee_list"
          :key="item.num"
          :label="item.name"
          :value="item.num">
        </el-option>
      </el-select>
      <el-date-picker
        v-model="time"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions">
      </el-date-picker>
      <el-button type="primary" @click="operation_change()">检索</el-button>
      <el-button type="primary" @click="operation_load_excel()">整体导出</el-button>
    </div>

    <el-table stripe :data="operation_list.data" style="width: 100% ;margin-top: 20px;" :row-style="{height:'70px'}">
      <el-table-column label="编号" prop="num" width="300" sortable>
      </el-table-column>
      <el-table-column label="操作人" prop="rale_name"   width="300"  sortable>
      </el-table-column>
      <el-table-column label="操作详情" prop="info"  width=""  sortable>
      </el-table-column>
      <el-table-column align="right"  width="300" label="时间">
        <template slot-scope="scope">
          <span>{{scope.row.time}}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="operation_list.current_page" :page-sizes="[10, 20, 30, 40]" :page-size="operation_list.per_page"
        layout="total, sizes, prev, pager, next, jumper" :total="operation_list.total">
      </el-pagination>
    </div>

  </div>
  </div>
</template>

<script>
  import load from '../../../../components/load.vue';
  export default {
    data() {
      return {
        liad_show:'',
        companyee_list:{},
        operation_list:{
          current_page: 1, // 当前页码
          total: 0, // 总条数
          per_page: 10,
          time:'_',
          companyee:'',
        },
        companyee_choiced:[],
        time:null,
        search: '',
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    components: {
      load:load
    },
    mounted() {
      this.get_companyee()
    },
    methods: {
      operation_load_excel(){
        let _this=this
        _this.liad_show=true
        var data={}
        if(_this.time==null){
          data.time='_'
        }else{
          data.time=_this.time[0]+"_"+_this.time[1]
        }
        data.companyee=_this.companyee_choiced.toString()
        _this.axios.post('/v2/c_census/operation_load_excel',{data:data},{responseType:'blob'}).then(function(res) {
          if(res.status=='200'){
             _this.liad_show=false
            const blob = new Blob([res.data],{type: 'aplication/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'})
            const elink = document.createElement('a')
            elink.download = '员工操作详情.xlsx';
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      operation_change(){
        let _this=this
        _this.liad_show=true
        if(_this.time==null){
          _this.operation_list.time='_'
        }else{
          _this.operation_list.time=_this.time[0]+"_"+_this.time[1]
        }
        _this.operation_list.companyee=_this.companyee_choiced.toString()
        _this.operation_list.current_page=1
        _this.operation_list.total=0
        _this.operation_list.per_page=10
        _this.get_operation()
        _this.liad_show=false
      },

      get_companyee(){
        let _this=this
        _this.liad_show=true
        _this.axios.get("/v2/c_companyee/get_list",{params:{'page':1,'limit':99999}}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
                _this.companyee_list=res.data.data.list
                _this.get_operation()
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },

      get_operation(){
        let _this=this
        _this.axios.get("/v2/c_census/get_operation",{params:{'page':_this.operation_list.current_page,'limit':_this.operation_list.per_page,'time':_this.operation_list.time,'companyee':_this.operation_list.companyee}}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
                _this.operation_list=res.data.data
                _this.operation_list.per_page=parseInt(_this.operation_list.per_page)
                _this.liad_show=false
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },

      handleSizeChange(val) {
        this.operation_list.current_page = 1
        this.operation_list.per_page = val
        this.get_operation()
      },

      handleCurrentChange(val) {
        let _this=this
        _this.operation_list.current_page = val
        _this.get_operation()
      }
    },
  }
</script>

<style scoped>
  #app{
   padding-bottom: 5%;
   background-color: white;
   height: 100%;
   padding-top: 20px;
  }
  .maincon {
   padding: 20px;
   height: calc(100vh - 40px);
  }

  .block {
    text-align: center;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/census/operation/operation.vue